import React, { useContext, useEffect } from "react"
import { Grid } from "@material-ui/core"
import { FormProvider, useForm } from "react-hook-form";
import { QuoteContextStore } from "../../../context/QuoteContext/QuoteContext";
import AirportCodeAutocomplete from "./AirportCodeAutocomplete";
import AirportCodeTableView from "./AirportCodeTableView";
import { yupResolver } from '@hookform/resolvers/yup';
import { airportSchema } from "../AirportStep";
import { FlowBackButton } from "../../Core/Buttons/FlowBackButton";
import { OrangeButton } from "../../Core/Buttons/OrangeButton";

const surfaceDict = {
    "ASPH": "Asphalt",
    "CONC": "Concrete",
    "TURF": "Turf/Grass",
    "GRVL": "Gravel",
    "DIRT": "Dirt"
}

const AirportCodeForm = ({submit}) => {
    const { airports,locked_quote } = useContext(QuoteContextStore)
    const form = useForm({mode: 'onBlur' ,defaultValues: {...airports[Object.keys(airports)[0]]}, resolver: yupResolver(airportSchema)});

    useEffect(() => {
        form.reset({...airports[Object.keys(airports)[0]]})
    }, [airports[Object.keys(airports)[0]]])

    return (
        <form onSubmit={form.handleSubmit(submit)}>
            <FormProvider {...form}>
                <Grid container item xs={12} sm={12} lg={6} spacing={2}>
                    <Grid item xs={12}>
                        <AirportCodeAutocomplete/>
                    </Grid>
                </Grid>
                <AirportCodeTableView/>
                <input hidden {...form.register("name")} />
                <input hidden {...form.register("state")} />
                <input hidden {...form.register("code")} />
                <input hidden {...form.register("city")} />
                <input hidden {...form.register("runway_elevation")} />
                <input hidden {...form.register("runway_length")} />
                <input hidden {...form.register("runway_surface")} />
                <input hidden {...form.register("airport_not_found")} />
            </FormProvider>
            <Grid className="margin-top-basic">
                <FlowBackButton />
                <OrangeButton type="submit">Save & Continue</OrangeButton>
            </Grid>
        </form>
    )
}

export default AirportCodeForm;